import {
  BrokerApproval,
  BrokerApprovalVariables,
} from "_graphql/mutation/__generated__/BrokerApproval";
import { Modal, OfficeButton } from "components";
import { useAppSearch, useCurrentUser } from "_graphql/cache/auth";

import { BrokerApproval as BrokerApprovalForm } from "components/forms";
import { LocationGenerics } from "router/location";
import { approveUnderwriter } from "_graphql/place-it/mutations/underwriter.place-it";
import { placeItClient } from "_graphql";
import toast from "react-hot-toast";
import { useFormik } from "formik";
import { useMutation } from "@apollo/client";
import { useNavigate } from "react-location";

export default function ApproveContainer({
  open,
  setOpen,
}: {
  open: boolean;
  setOpen: (val: boolean) => void;
  refetch?: () => void;
}) {
  const searchParams = useAppSearch();
  const navigate = useNavigate<LocationGenerics>();
  const [execute, { loading }] = useMutation<
    BrokerApproval,
    BrokerApprovalVariables
  >(approveUnderwriter, {
    client: placeItClient,
    refetchQueries: ["GetUnderwriters"],
  });
  const currentUser = useCurrentUser();

  const form = useFormik<any>({
    initialValues: {
      approval_state: "",
      reason: "",
    },
    onSubmit: async (values, helpers) => {
      execute({
        variables: {
          approvalState: values.approval_state,
          associateId: searchParams?.id || "",
          comment: values.reason,
          employeeName: `${currentUser?.employee?.employee_first_name} ${currentUser?.employee?.employee_last_name}`,
        },
      })
        .then(({ data }) => {
          if (data?.brokerApproval?.message) {
            helpers.resetForm();
            toast.success(
              data?.brokerApproval?.message ||
                "Underwriter approved successfully"
            );
            navigate({
              search(prev) {
                return {
                  ...prev,
                  id: undefined,
                  modal: undefined,
                };
              },
            });
          }
        })
        .catch((err) => {
          toast.error("Could not approve underwriter");
        });
    },
    onReset: () => {
      setOpen(false);
      navigate({
        search(prev) {
          return {
            ...prev,
            id: undefined,
            modal: undefined,
          };
        },
      });
    },
  });

  return (
    <Modal
      open={open}
      setOpen={() => {
        setOpen(false);
        navigate({
          search(prev) {
            return {
              ...prev,
              rate: undefined,
              modal: undefined,
            };
          },
        });
      }}
      title="Approve Underwriter"
      // loading={fetchingClaim}
      description="Approve Underwriter"
      renderActions={() => (
        <div className="flex flex-row justify-end">
          <OfficeButton
            onClick={() => {
              form.submitForm();
            }}
          >
            {loading ? "Please wait ..." : "Approve"}
          </OfficeButton>
        </div>
      )}
    >
      {/* {JSON.stringify(form.values, null, 2)} */}
      <BrokerApprovalForm form={form} />
    </Modal>
  );
}
